import { ApolloError } from '@apollo/client';
import { FC } from 'react';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';
import LoadingIndicator from 'primitives/LoadingIndicator';

import DataTable from 'components/DataTable';
import ErrorMessage from 'components/ErrorMessage';

interface GenerateListDialogButtonProps {
  className?: string;
  data: any[];
  loading: boolean;
  error?: ApolloError;
  showDialog: boolean;
  onOpenDialog: () => void;
  onCloseDialog: () => void;
  onSendReminders: () => void;
  sendRemindersLoading: boolean;
}

const GenerateListDialogButton: FC<GenerateListDialogButtonProps> = ({
  className,
  data,
  loading,
  error,
  showDialog,
  onOpenDialog,
  onCloseDialog,
  onSendReminders,
  sendRemindersLoading,
}) => {
  return (
    <>
      <Button variant="secondary" onClick={onOpenDialog} className={className}>
        Generate List
      </Button>
      <Dialog open={showDialog} onClose={onCloseDialog}>
        <DialogPanel className="min-w-[768px]">
          <DialogTitle>Generate List</DialogTitle>
          {loading ? (
            <LoadingIndicator />
          ) : error ? (
            <ErrorMessage error={error} />
          ) : (
            <>
              <div className="my-4 flex flex-row justify-between items-center">
                <p>Total reminders to be sent: {data.length}</p>
                <Button onClick={onSendReminders} loading={sendRemindersLoading}>
                  Send reminders
                </Button>
              </div>
              <DataTable
                data={data}
                columns={[
                  {
                    label: 'Name',
                    fieldName: 'name',
                  },
                  {
                    label: 'Email',
                    fieldName: 'user.email',
                  },
                  {
                    label: 'Type',
                    fieldName: 'type',
                    type: 'INVESTMENT_ENTITY_TYPE',
                  },
                  {
                    label: 'Status',
                    fieldName: 'status',
                    type: 'STATUS',
                  },
                  {
                    label: 'Created At',
                    fieldName: 'createdAt',
                    type: 'DATE',
                  },
                ]}
              />
            </>
          )}
          <DialogActions>
            <Button variant="secondary" onClick={onCloseDialog}>
              Close
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default GenerateListDialogButton;
